import Api from '@/services/Api'

export default {
 getProcedures () {
   return Api().get("/procedures");
},
  updateProcedure (params) {
    return Api().put("/procedures",params);
  },
  addProcedure (params) {
    return Api().post("/procedures",params);
  },
  getProcedure (params) {
    return Api().get("/procedures/"+params);
  },
  deleteProcedure(params) {
    return Api().delete("/procedures/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/ProcedureService.js